"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./ListGroup.scss");

var _excluded = ["className", "removeBorders"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Use `<ListGroupItem>` as children */
  children: _propTypes.node.isRequired,

  /** Removes borders from the items */
  removeBorders: _propTypes.bool,

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
/** The ListGroup is a component for displaying a series of content.
 * Its children can contain just about anything and are customizable.
 * @visibleName List Group
 * */

var ListGroup = function ListGroup(_ref) {
  var className = _ref.className,
      removeBorders = _ref.removeBorders,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-list-group', {
    'rds-list-group--no-borders': removeBorders
  }, className);
  return /*#__PURE__*/_react.default.createElement("ul", _extends({
    className: componentClassNames
  }, rest));
};

ListGroup.propTypes = propTypes;
var _default = ListGroup;
exports.default = _default;